"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function addTargetBlankToSelector(selector) {
  var linkList = document.querySelectorAll(selector);

  for (var i = 0; i < linkList.length; i += 1) {
    linkList[i].setAttribute('target', '_blank');
  }
}

exports.addTargetBlankToSelector = addTargetBlankToSelector;
var DOM_UTILS = {
  addTargetBlankToSelector: addTargetBlankToSelector
};
exports.default = DOM_UTILS;